/// <reference path="transactionEditor.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.TransactionEditor {

    export class TransactionEditorController {

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "meevo.components.common.PrintService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "$mdDialog",
            "$mdToast",
            "$cookies",
            "$translate",
            "$q",
            "meevo.components.busy.BusyService",
            "meevo.components.common.ReportRouterService",
            "meevo.components.common.RoundingService",
            "meevoDateFilterFilter",
            "$timeout",
            "meevo.plugins.register.RegisterDiscountService",
            "$compile",
            "meevo.plugins.register.RegisterPaymentPlanService",
            "meevo.plugins.tippy.tippyService",
            "meevo.plugins.transactionEditor.transactionEditorService"
        ];

        public context: TransactionEditorContext;
        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

        constructor(
            public appSettings: Meevo.Components.Common.IAppSettings,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            public modalService: Meevo.Components.Modal.IModalService,
            public identityService: Meevo.Components.Common.IIdentityService,
            public loggingService: Meevo.Components.Logging.ILoggingService,
            public securityService: Meevo.Components.Common.ISecurityService,
            public trackingService: Meevo.Components.Tracking.ITrackingService,
            public printService: Meevo.Components.Common.IPrintService,
            public $rootScope: angular.IRootScopeService,
            public $scope: angular.IScope,
            public $state: any,
            public contextParams: Meevo.IContextParams,
            public shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            public $mdDialog: angular.material.IDialogService,
            public $mdToast: angular.material.IToastService,
            public $cookies: angular.cookies.ICookiesService,
            public $translate: angular.translate.ITranslateService,
            public $q: ng.IQService,
            public busyService: Meevo.Components.Busy.IBusyService,
            public reportRouterService: Meevo.Components.Common.ReportRouterService,
            public roundingService: Meevo.Components.Common.RoundingService,
            public meevoDateFilter: any,
            public $timeout: ng.ITimeoutService,
            public registerDiscountService: Meevo.Plugins.Register.RegisterDiscountService,
            public $compile: ng.ICompileService,
            public paymentPlanService: Meevo.Plugins.Register.RegisterPaymentPlanService,
            public tippyService: Meevo.Plugins.Tippy.TippyService,
            public transactionEditorService: TransactionEditorService
        ) {

            this.context = new TransactionEditorContext(this, this.contextParams.params);

            this.$scope.$on(Meevo.Components.Common.Messages.CLOSE_CONTEXT_WARNING, (event, state, params) => {
                if (state.name == this.appSettings.ROUTE_NAMES.transactionEditor) {
                    this.$rootScope.$broadcast("closeContext", state, null);
                }
            });

            this.$scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, (event, state, params) => {
                if (state.name == this.appSettings.ROUTE_NAMES.transactionEditor) {
                    this.processContextParams(params);
                }
            });

            if (contextParams.params) {
                this.$timeout(() => {
                    this.processContextParams(contextParams.params);
                });
            }
        }

        processContextParams(params: any): void {
            var context = <TransactionEditorContext>this.context;
            context.forcePageLoading(params);
        }

        closeContext = (): void => {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
        }

    }

    angular.module("meevo.plugins.transactionEditor")
        .controller("meevo.plugins.transactionEditor.TransactionEditorController", TransactionEditorController);

}